export default class RevistaDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, RevistaService, Revista, RevistaEquipaEditorial, RevistaIndicador, Ranking, Investigador, RevistaEquipaEditorialFuncao) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.RevistaService = RevistaService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Revista = Revista;
    this.RevistaEquipaEditorial = RevistaEquipaEditorial;
    this.RevistaIndicador = RevistaIndicador;
    this.Ranking = Ranking;
    this.Investigador = Investigador;
    this.RevistaEquipaEditorialFuncao = RevistaEquipaEditorialFuncao;
    this.showEstadosPanel = false;

    this.loaded = false;

    // Default opt state - populate later when we have all states
    this.optEquipaEditorial = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.equipaEditorial = null;
    this.equipaEditorialLoading = true;

    // Default opt state - populate later when we have all states
    this.optIndicadores = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.indicadores = null;
    this.indicadoresLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Revista.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', {
          relation: 'equipaEditorial',
          scope: {
            include: {
              relation: 'investigador',
              scope: {
                fields: {userId: true}
              }
            }
          }
        }]
      }
    }).$promise.then(res => {
      this.data = res;

      this.getEquipaEditorialForRevista();
      this.getIndicadoresForRevista();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.revista.list');
      this.UI.addToast('Erro ao carregar revista. Verifique a ligação');
    });
  };

  editDetalhes = () => {
    let options = {
      size: 'lg',
      template: require('./details.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Revista";
        $scope.revista = angular.copy(this.data);
        $scope.simnao = this.simnao;

        $scope.auxScopus = {
          selected: $scope.revista.scopus ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.isValidISSN = this.RevistaService.isValidISSN;

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.revista.issnOnline && ok.revista.issnOnline.length > 0 && !this.RevistaService.isValidISSN(ok.revista.issnOnline)) {
        this.UI.addToast("ISSN Online inválido");
        this.loaded = true;
        return;
      }
      if (!this.RevistaService.isValidISSN(ok.revista.issn)) {
        this.UI.addToast("ISSN inválido");
        this.loaded = true;
        return;
      }

      // To check if either issn or issn online exist in the database
      let whereOr = [];
      if (ok.revista.issn && ok.revista.issn.length > 0) {
        whereOr.push({issn: ok.revista.issn}, {issnOnline: ok.revista.issn});
      }
      if (ok.revista.issnOnline && ok.revista.issnOnline.length > 0) {
        whereOr.push({issn: ok.revista.issnOnline}, {issnOnline: ok.revista.issnOnline});
      }

      this.Revista.find({ // Find ISSN in other revistas
        filter: {
          fields: {id: true},
          where: {
            and: [{id: {neq: this.data.id}}, {or: whereOr}]
          }
        }
      }).$promise.then((res) => {
        if (res.length > 0) { //
          let alert = this.UI.showAlert("ISSN já está registado para outra revista");
          alert.finally(() => {
            this.loadData();
          });
        } else { // No other ISSN used by another revista, ok
          this.data.scopus = ok.auxScopus.selected.value;
          this.data.issn = ok.revista.issn;
          this.data.issnOnline = ok.revista.issnOnline;
          this.data.local = ok.revista.local || null;
          this.data.nome = ok.revista.nome;

          this.data.atualizadoPorId = this.user.id;
          this.data.atualizadoa = moment().format();

          this.Revista.upsert(this.data).$promise.then((revista) => {
            this.RevistaService.checkRevistaPublicacao(revista).then(() => {
              this.UI.addToast("Dados atualizados com sucesso");
              this.loadData();
            }).catch(error => {
              this.UI.addToast("Dados atualizados com sucesso, falha ao atualizar publicações");
              this.loadData();
            });
          }).catch((error) => {
            console.log(error);
            this.UI.showAlert("Erro ao atualizar revista. Verifique a ligação");
            this.loaded = true;
          });
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível verificar dados. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  editObservacoes = () => {
    let options = {
      size: 'lg',
      template: require('./observacoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Observações";
        $scope.observacoes = angular.copy(this.data.observacoes);

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;

      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();

      this.Revista.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Observações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar revista. Verifique a ligação");
        this.loaded = true;
      });
    });
  };


  // Multiple data
  // Equipa Editorial
  equipaEditorialModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let membroEquipaEditorial = {};
    let auxFuncaoSelection = undefined;
    let auxInvestigadorSelection = undefined;
    if (edit && data != null) {
      membroEquipaEditorial = angular.copy(data);
      auxFuncaoSelection = membroEquipaEditorial.funcao;
      auxInvestigadorSelection = membroEquipaEditorial.investigador;
    }
    let wait = this.UI.showWaiting();
    this.RevistaEquipaEditorialFuncao.find({}).$promise.then((funcoes) => {
      this.Investigador.find({}).$promise.then((investigadores) => {
        investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
        wait.close();
        defer.resolve({
          size: 'lg',
          template: require('./../new/edit.equipa.editorial.dialog.html'),
          controller: ['$dialog', '$scope', (dialog, scope) => {
            scope.label = (edit ? "Editar" : "Novo") + " membro de Equipa Editorial";
            scope.membroEquipaEditorial = membroEquipaEditorial;
            scope.funcoes = funcoes;
            scope.investigadores = investigadores;
            scope.removeDate = this.UI.removeDate;
            scope.dateOptions = {
              dataEntrada: {format: 'DD/MM/YYYY'},
              dataSaida: {format: 'DD/MM/YYYY'}
            };

            scope.auxFuncao = {
              selected: auxFuncaoSelection,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };

            scope.auxInvestigador= {
              selected: auxInvestigadorSelection,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };

            // Infinite Scroll magic
            scope.addMoreItems = (infiniteScroll) => {
              infiniteScroll.currentItems += infiniteScroll.numToAdd;
            };

            scope.ok = () => {
              dialog.close(scope);
            };

            scope.cancel = () => {
              dialog.dismiss('cancel');
            };
          }]
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
        defer.reject();
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler funções de equipa editorial. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo membro de equipa editorial para revista
  addEquipaEditorial = () => {
    this.equipaEditorialModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxFuncao && ok.auxInvestigador && ok.membroEquipaEditorial) {
          this.equipaEditorialLoading = true;
          let item = angular.copy(ok.membroEquipaEditorial);
          item.dataEntrada = item.dataEntrada.format(); // Use text instead of moment
          if (item.dataSaida != null && item.dataSaida.isValid()) // null, undefined or invalid date
            item.dataSaida = item.dataSaida.format(); // Use text instead of moment
          else
            item.dataSaida = null;
          item.funcaoId = ok.auxFuncao.selected.id;
          item.funcao = angular.copy(ok.auxFuncao.selected);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);

          this.RevistaService.createMultipleData(this.RevistaEquipaEditorial, [item], this.id, 'revistaId').then((x) => {
            this.UI.addToast("Membro de Equipa Editorial adicionado com sucesso");
            this.getEquipaEditorialForRevista();
          }).catch(error => {
            this.equipaEditorialLoading = false;
            this.UI.addToast("Erro ao inserir membro de equipa editorial. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Edita informação de equipa editorial para revista
  editEquipaEditorial = (x) => {
    this.equipaEditorialModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxFuncao && ok.auxInvestigador && ok.membroEquipaEditorial) {
          this.equipaEditorialLoading = true;
          // Update data without replacing the variable x (so it's still an element of the array)
          x.dataEntrada = ok.membroEquipaEditorial.dataEntrada.format(); // Use text instead of moment
          if (ok.membroEquipaEditorial.dataSaida != null && ok.membroEquipaEditorial.dataSaida.isValid()) // null, undefined or invalid date
            x.dataSaida = ok.membroEquipaEditorial.dataSaida.format(); // Use text instead of moment
          else
            x.dataSaida = null;
          x.funcaoId = ok.auxFuncao.selected.id;
          x.funcao = angular.copy(ok.auxFuncao.selected);
          x.investigadorId = ok.auxInvestigador.selected.id;
          x.investigador = angular.copy(ok.auxInvestigador.selected);

          this.RevistaService.updateMultipleData(this.RevistaEquipaEditorial, [x]).then((res) => {
            this.UI.addToast("Membro de Equipa Editorial atualizado com sucesso");
            this.getEquipaEditorialForRevista();
          }).catch((error) => {
            this.equipaEditorialLoading = false;
            this.UI.addToast("Erro ao atualizar equipa editorial. Verifique a ligação");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteEquipaEditorial = (x) => {
    let title = "Eliminar Membro de Equipa Editorial";
    let warning = "Tem a certeza que pretende remover este registo de membro da equipa editorial?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeEquipaEditorial(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeEquipaEditorial = (x) => {
    this.equipaEditorialLoading = true;
    // Find again equipa editorial to delete so we can update it
    this.RevistaEquipaEditorial.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((membroEquipaEditorialToRemove) => {
      // Only for mandatory existing multiple data
      this.RevistaEquipaEditorial.count({
        fields: {id: true},
        where: {
          revistaId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other membros still remaining

          // Remove data
          this.RevistaEquipaEditorial.deleteById({
            id: membroEquipaEditorialToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Membro de Equipa Editorial removido com sucesso");
            this.getEquipaEditorialForRevista();
          });

        } else { // No other graus academicos exist, can't remove
          this.equipaEditorialLoading = false;
          this.UI.showAlert("Não foi possível apagar membro de equipa editorial porque tem que haver pelo menos 1 registo para a revista");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar equipa editorial. Verifique a ligação");
        this.getEquipaEditorialForRevista();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar membro. Verifique se ainda existe.");
      this.getEquipaEditorialForRevista();
    });
  };

  getEquipaEditorialForRevista = () => {
    this.equipaEditorialLoading = true;
    let whereLiteral = {
      'RevistaEquipaEditorial.revistaId': this.id
    };
    let where = {};
    Object.keys(this.optEquipaEditorial.filter).forEach(f => {
      if (this.optEquipaEditorial.filter[f])
        where[f] = this.optEquipaEditorial.filter[f];
    });
    this.RevistaEquipaEditorial.table({
      params: {
        fields: [
          'RevistaEquipaEditorial.id as id',
          'RevistaEquipaEditorial.revistaId as revistaId',
          'RevistaEquipaEditorial.investigadorId as investigadorId',
          'RevistaEquipaEditorial.funcaoId as funcaoId',
          'RevistaEquipaEditorial.dataEntrada as dataEntrada',
          'RevistaEquipaEditorial.dataSaida as dataSaida',
          'RevistaEquipaEditorial.dataCriacao as dataCriacao',
          'RevistaEquipaEditorial.atualizadoa as atualizadoa',
          'RevistaEquipaEditorial.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'RevistaEquipaEditorialFuncao.id as auxFuncaoId',
          'RevistaEquipaEditorialFuncao.designacao as auxFuncaoDesignacao',
          'Investigador.id as auxInvestigadorId',
          'Investigador.nome as auxInvestigadorNome'
        ],
        from: ['RevistaEquipaEditorial', 'User', 'User', 'RevistaEquipaEditorialFuncao', 'Investigador'],
        references: [undefined, 'RevistaEquipaEditorial.criadoPorId', 'RevistaEquipaEditorial.atualizadoPorId', 'RevistaEquipaEditorial.funcaoId', 'RevistaEquipaEditorial.investigadorId'],
        aliases: [null, null, 'User2', null, null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optEquipaEditorial.order,
        sort: this.optEquipaEditorial.sort,
        limit: this.optEquipaEditorial.items,
        skip: (this.optEquipaEditorial.page - 1) * this.optEquipaEditorial.items,
      }
    }).$promise.then(res => {
      let page = this.optEquipaEditorial.page;
      let items = this.optEquipaEditorial.items;

      let total = res.count;

      this.optEquipaEditorial.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optEquipaEditorial.start - 1 + items) >= total) {
        this.optEquipaEditorial.end = total;
      } else {
        this.optEquipaEditorial.end = Number.parseInt(this.optEquipaEditorial.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.funcao = {
          id: x.auxFuncaoId,
          designacao: x.auxFuncaoDesignacao
        };
        x.investigador = {
          id: x.auxInvestigadorId,
          nome: x.auxInvestigadorNome
        };
      });

      this.equipaEditorial = res.data;
      this.optEquipaEditorial.total = total;
      this.equipaEditorialLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler equipa editorial. Verifique a ligação");
    });
  };

  equipaEditorialSort = keyname => {
    if (this.optEquipaEditorial.order === keyname)
      this.optEquipaEditorial.page = 1;
    this.optEquipaEditorial.order = keyname;
    this.optEquipaEditorial.sort = this.optEquipaEditorial.sort === 'asc' ? 'desc' : 'asc';
    this.getEquipaEditorialForRevista();
  };

  equipaEditorialItem = val => {
    this.optEquipaEditorial.items = val;
    this.optEquipaEditorial.page = 1;
    this.getEquipaEditorialForRevista();
  };

  equipaEditorialPage = sum => {
    this.optEquipaEditorial.page += sum;
    if (this.optEquipaEditorial.page < 1)
      this.optEquipaEditorial.page = 1;
    if (this.optEquipaEditorial.page > Math.ceil(this.optEquipaEditorial.total / this.optEquipaEditorial.items))
      this.optEquipaEditorial.page = Math.ceil(this.optEquipaEditorial.total / this.optEquipaEditorial.items);
    this.getEquipaEditorialForRevista();
  };

  viewEquipaEditorial = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./equipa.editorial.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataEntrada = moment($scope.data.dataEntrada).isValid() ? moment($scope.data.dataEntrada).format('DD/MM/YYYY') : null;
        $scope.data.dataSaida = moment($scope.data.dataSaida).isValid() ? moment($scope.data.dataSaida).format('DD/MM/YYYY') : null;
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };



  // Indicadores
  indicadoreslModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let indicador = {};
    let auxRankingSelection = undefined;
    if (edit && data != null) {
      indicador = angular.copy(data);
      auxRankingSelection = indicador.ranking;
    }
    let wait = this.UI.showWaiting();
    this.Ranking.find({}).$promise.then((rankings) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.indicador.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Indicador";
          scope.indicador = indicador;
          scope.rankings = rankings;

          scope.auxRanking = {
            selected: auxRankingSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler rankings para indicadores. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo indicador para revista
  addIndicador = () => {
    this.indicadoreslModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxRanking && ok.indicador) {
          this.indicadoresLoading = true;
          this.RevistaService.usedPartialDataForModel({
            ano: ok.indicador.ano,
            revistaId: this.data.id
          }, this.RevistaIndicador).then(anos => {
            if (anos.count > 0) { // Ano used, reject creation
              this.UI.showAlert("Já existem indicadores para o ano " + ok.indicador.ano + ". Edite os valores diretamente");
              this.indicadoresLoading = false;
            } else { // Ano is free, add it
              let item = angular.copy(ok.indicador);
              item.rankingId = ok.auxRanking.selected.id;
              item.ranking = angular.copy(ok.auxRanking.selected);

              this.RevistaService.createMultipleData(this.RevistaIndicador, [item], this.id, 'revistaId').then((x) => {
                this.UI.addToast("Indicador adicionado com sucesso");
                this.getIndicadoresForRevista();
              }).catch(error => {
                this.indicadoresLoading = false;
                this.UI.addToast("Erro ao inserir indicador. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            console.log(error);
            this.UI.showAlert("Erro na validação de indicador. Verifique a ligação");
            this.indicadoresLoading = false;
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Edita informação de indicador para revista
  editIndicador = (x) => {
    this.indicadoreslModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxRanking && ok.indicador) {
          this.indicadoresLoading = true;
          this.RevistaService.usedPartialDataForModel({
            ano: ok.indicador.ano,
            revistaId: this.data.id
          }, this.RevistaIndicador, x.id).then(anos => {
            if (anos.count > 0) { // Ano used, reject editing
              this.UI.showAlert("Já existem indicadores para o ano " + ok.indicador.ano + ". Edite os valores diretamente");
              this.indicadoresLoading = false;
            } else { // Ano is free, edit it
              // Update data without replacing the variable x (so it's still an element of the array)
              x.ano = ok.indicador.ano;
              x.impactFactor = ok.indicador.impactFactor;
              x.eigenFactor = ok.indicador.eigenFactor;

              x.rankingId = ok.auxRanking.selected.id;
              x.ranking = angular.copy(ok.auxRanking.selected);
              this.RevistaService.updateMultipleData(this.RevistaIndicador, [x]).then((res) => {
                this.UI.addToast("Indicador atualizado com sucesso");
                this.getIndicadoresForRevista();
              }).catch((error) => {
                this.indicadoresLoading = false;
                this.UI.addToast("Erro ao atualizar indicador. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            console.log(error);
            this.UI.showAlert("Erro na validação de indicador. Verifique a ligação");
            this.indicadoresLoading = false;
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete indicador
  confirmDeleteIndicador = (x) => {
    let title = "Eliminar Indicadores";
    let warning = "Tem a certeza que pretende remover esta entrada de indicadores?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeIndicador(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeIndicador = (x) => {
    this.indicadoresLoading = true;
    // Find again indicador to delete so we can update it
    this.RevistaIndicador.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((indicadorToRemove) => {

      // Remove data
      this.RevistaIndicador.deleteById({
        id: indicadorToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Indicadores removidos com sucesso");
        this.getIndicadoresForRevista();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar indicadores. Verifique se ainda existe.");
      this.getIndicadoresForRevista();
    });
  };

  getIndicadoresForRevista = () => {
    this.indicadoresLoading = true;
    let whereLiteral = {
      'RevistaIndicador.revistaId': this.id
    };
    let where = {};
    Object.keys(this.optIndicadores.filter).forEach(f => {
      if (this.optIndicadores.filter[f])
        where[f] = this.optIndicadores.filter[f];
    });
    this.RevistaIndicador.table({
      params: {
        fields: [
          'RevistaIndicador.id as id',
          'RevistaIndicador.revistaId as revistaId',
          'RevistaIndicador.ano as ano',
          'RevistaIndicador.rankingId as rankingId',
          'RevistaIndicador.impactFactor as impactFactor',
          'RevistaIndicador.eigenFactor as eigenFactor',
          'RevistaIndicador.dataCriacao as dataCriacao',
          'RevistaIndicador.atualizadoa as atualizadoa',
          'RevistaIndicador.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Ranking.id as auxRankingId',
          'Ranking.designacao as auxRankingDesignacao',
        ],
        from: ['RevistaIndicador', 'User', 'User', 'Ranking'],
        references: [undefined, 'RevistaIndicador.criadoPorId', 'RevistaIndicador.atualizadoPorId', 'RevistaIndicador.rankingId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optIndicadores.order,
        sort: this.optIndicadores.sort,
        limit: this.optIndicadores.items,
        skip: (this.optIndicadores.page - 1) * this.optIndicadores.items,
      }
    }).$promise.then(res => {
      let page = this.optIndicadores.page;
      let items = this.optIndicadores.items;

      let total = res.count;

      this.optIndicadores.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optIndicadores.start - 1 + items) >= total) {
        this.optIndicadores.end = total;
      } else {
        this.optIndicadores.end = Number.parseInt(this.optIndicadores.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.ranking = {
          id: x.auxRankingId,
          designacao: x.auxRankingDesignacao
        };
      });

      this.indicadores = res.data;
      this.optIndicadores.total = total;
      this.indicadoresLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler indicadores. Verifique a ligação");
    });
  };

  indicadoresSort = keyname => {
    if (this.optIndicadores.order === keyname)
      this.optIndicadores.page = 1;
    this.optIndicadores.order = keyname;
    this.optIndicadores.sort = this.optIndicadores.sort === 'asc' ? 'desc' : 'asc';
    this.getIndicadoresForRevista();
  };

  indicadoresItem = val => {
    this.optIndicadores.items = val;
    this.optIndicadores.page = 1;
    this.getIndicadoresForRevista();
  };

  indicadoresPage = sum => {
    this.optIndicadores.page += sum;
    if (this.optIndicadores.page < 1)
      this.optIndicadores.page = 1;
    if (this.optIndicadores.page > Math.ceil(this.optIndicadores.total / this.optIndicadores.items))
      this.optIndicadores.page = Math.ceil(this.optIndicadores.total / this.optIndicadores.items);
    this.getIndicadoresForRevista();
  };

  viewIndicador = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./indicador.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.RevistaService.canRead('revistaRead', true, 'revistaReadAny', this.RevistaService.getEquipaEditorialUserId(this.data));
  canEditGeneral = () => this.RevistaService.canEdit('revistaEdit', true, 'revistaEditAny', this.RevistaService.getEquipaEditorialUserId(this.data));

  canReadAdicional = () => this.RevistaService.canRead('revistaReadAdicional', true, 'revistaReadAdicionalAny', this.RevistaService.getEquipaEditorialUserId(this.data));
  canEditAdicional = () => this.RevistaService.canEdit('revistaEditAdicional', true, 'revistaEditAdicionalAny', this.RevistaService.getEquipaEditorialUserId(this.data));

  canReadEquipaEditorial = () => this.RevistaService.canRead('revistaReadEquipaEditorial', true, 'revistaReadEquipaEditorialAny', this.RevistaService.getEquipaEditorialUserId(this.data));
  canEditEquipaEditorial = () => this.RevistaService.canEdit('revistaEditEquipaEditorial', true, 'revistaEditEquipaEditorialAny', this.RevistaService.getEquipaEditorialUserId(this.data));

  canReadIndicador = () => this.RevistaService.canRead('revistaReadIndicador', true, 'revistaReadIndicadorAny', this.RevistaService.getEquipaEditorialUserId(this.data));
  canEditIndicador = () => this.RevistaService.canEdit('revistaEditIndicador', true, 'revistaEditIndicadorAny', this.RevistaService.getEquipaEditorialUserId(this.data));

}

RevistaDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'RevistaService', 'Revista', 'RevistaEquipaEditorial', 'RevistaIndicador', 'Ranking', 'Investigador', 'RevistaEquipaEditorialFuncao'];
